import { getApps, initializeApp } from "firebase/app";
import { RecaptchaVerifier, getAuth, signInWithPhoneNumber, signOut } from "firebase/auth";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

const auth = () => getAuth(getApps()[0] || initializeApp(config));
let verifier = null;

const MESSAGES = {
  "auth/invalid-phone-number": "That mobile number doesn't look right. Please change your details.",
  "auth/too-many-requests": "Too many codes were sent to this number. Please wait a while and try again.",
  "auth/quota-exceeded": "We can't send text messages just now. Please try again later.",
  "auth/invalid-verification-code": "The text message code isn't right. Check it, or send a new one.",
  "auth/code-expired": "The text message code has expired. Please send a new one.",
};
export const phoneError = (err) => MESSAGES[err?.code] || "We couldn't send or check the text message code. Please try again.";

/** Texts a code to `phone` (E.164). `containerId` is an empty element for Firebase's invisible robot check. */
export const sendPhoneCode = async (phone, containerId) => {
  const a = auth();
  verifier?.clear();
  verifier = new RecaptchaVerifier(a, containerId, { size: "invisible" });
  return signInWithPhoneNumber(a, phone, verifier);
};

/** Confirms the code and returns a signed token the server checks. The Firebase session itself isn't kept. */
export const confirmPhoneCode = async (confirmation, code) => {
  const { user } = await confirmation.confirm(code);
  const token = await user.getIdToken();
  await signOut(auth());
  return token;
};
